<template>
    <div class="bmv-toast-container" data-testid="bmv-toast-container">
        <transition-group name="bmv-toast" tag="div" class="bmv-toast-stack">
            <div
                v-for="toast in toasts"
                :key="toast.id"
                class="bmv-toast"
                :class="`bmv-toast--${toast.type}`"
                role="status"
            >
                <i :class="iconFor(toast.type)" class="bmv-toast-icon"></i>
                <div class="bmv-toast-content">
                    <strong v-if="toast.title" class="bmv-toast-title">{{ toast.title }}</strong>
                    <span class="bmv-toast-message">{{ toast.message }}</span>
                </div>
                <button
                    type="button"
                    class="bmv-toast-close"
                    aria-label="Close"
                    @click="dismiss(toast.id)"
                >
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </transition-group>
    </div>
</template>

<script>
let nextId = 0

export default {
    name: 'BmvToastContainer',
    data() {
        return {
            toasts: []
        }
    },
    methods: {
        open(options) {
            const id = ++nextId
            const toast = {
                id,
                type: options.type || 'info',
                title: options.title || '',
                message: options.message || '',
                duration: options.duration != null ? options.duration : 4000
            }
            this.toasts.push(toast)
            if (toast.duration > 0) {
                setTimeout(() => this.dismiss(id), toast.duration)
            }
            return id
        },
        dismiss(id) {
            const i = this.toasts.findIndex((t) => t.id === id)
            if (i !== -1) this.toasts.splice(i, 1)
        },
        iconFor(type) {
            switch (type) {
                case 'success': return 'fal fa-check-circle'
                case 'warning': return 'fal fa-exclamation-triangle'
                case 'error':
                case 'danger': return 'fal fa-times-circle'
                default: return 'fal fa-info-circle'
            }
        }
    }
}
</script>

<style scoped>
.bmv-toast-container {
    position: fixed;
    top: var(--v2-space-4);
    right: var(--v2-space-4);
    z-index: 11000;
    pointer-events: none;
    font-family: var(--v2-font-sans);
}

.bmv-toast-stack {
    display: flex;
    flex-direction: column;
    gap: var(--v2-space-2);
}

.bmv-toast {
    pointer-events: auto;
    display: flex;
    align-items: flex-start;
    gap: var(--v2-space-3);
    min-width: 280px;
    max-width: 360px;
    padding: var(--v2-space-3) var(--v2-space-4);
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-left: 3px solid var(--v2-text-3);
    border-radius: var(--v2-radius-md);
    box-shadow: var(--v2-shadow-md);
    color: var(--v2-text-1);
    font-size: var(--v2-text-sm-size);
    line-height: var(--v2-text-sm-line);
}

.bmv-toast--success { border-left-color: var(--v2-success); }
.bmv-toast--warning { border-left-color: var(--v2-warning); }
.bmv-toast--error,
.bmv-toast--danger { border-left-color: var(--v2-danger); }
.bmv-toast--info { border-left-color: var(--v2-info); }

.bmv-toast-icon {
    font-size: 1rem;
    margin-top: 2px;
    flex-shrink: 0;
}

.bmv-toast--success .bmv-toast-icon { color: var(--v2-success); }
.bmv-toast--warning .bmv-toast-icon { color: var(--v2-warning); }
.bmv-toast--error .bmv-toast-icon,
.bmv-toast--danger .bmv-toast-icon { color: var(--v2-danger); }
.bmv-toast--info .bmv-toast-icon { color: var(--v2-info); }

.bmv-toast-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.bmv-toast-title {
    font-size: var(--v2-text-sm-size);
    font-weight: var(--v2-font-weight-semibold);
}

.bmv-toast-message {
    color: var(--v2-text-2);
}

.bmv-toast-close {
    background: transparent;
    border: none;
    color: var(--v2-text-4);
    cursor: pointer;
    padding: 2px;
    font-size: 0.8rem;
    margin-top: 2px;
    transition: color var(--v2-transition-fast);
}

.bmv-toast-close:hover {
    color: var(--v2-text-1);
}

/* transitions */
.bmv-toast-enter-active,
.bmv-toast-leave-active {
    transition: opacity var(--v2-transition-base),
        transform var(--v2-transition-base);
}
.bmv-toast-enter { opacity: 0; transform: translateX(20px); }
.bmv-toast-leave-to { opacity: 0; transform: translateX(20px); }
</style>
